export const DEFAULT_MAP_NAMESPACE = 'TM_IAD.AlertHistory';
export const DEFAULT_PAGINATION = {
  currentPage: 1,
  pageSize: 15
};
export const DOWNLOAD_LIMIT = 5000;
export const DEFAULT_WIDGET_TITLE = 'Alert History';
export const UNIFIED_ALERTS_SOURCE_IDS = [
  '0,1,6',
  '4,13',
  '2,3',
  '5,10,11,12,14,18',
  '21',
  '25,29'
];
export const UNIFIED_ALERTS_SOURCE_IDS_PREVENTION = ['7,8,9,16,17,20,24'];
